import { application } from "./application"

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import DailyChartController from "./daily_chart_controller"
application.register("daily-chart", DailyChartController)

import ActivityFilterController from "./activity_filter_controller"
application.register("activity-filter", ActivityFilterController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)
